<template>
  <mainTemplateVue>
    <div>
      <md-toolbar :md-elevation="0" class="md-transparent">
        <h3 class="md-title">{{ $route.name }}</h3>
        <md-button class="md-primary" to="/servico"
          >Voltar</md-button
        >
      </md-toolbar>

      <div>
        <md-card>
          <md-card-content>
            <form>
              <md-tabs class="md-transparent" md-alignment="left">
                <md-tab id="tab-home" md-label="Serviço">
                  <div>
                    <md-field :class="getValidationClass('servico_nome')">
                      <label for="servico_nome">Nome</label>
                      <md-input
                        v-model="form.servico_nome"
                        name="servico_nome"
                        id="servico_nome"
                        :disabled="sending"
                        required
                      />
                      <span
                        class="md-error"
                        v-if="!$v.form.servico_nome.required"
                        >O nome do serviço é obrigatório</span
                      >
                    </md-field>

                    <md-field :class="getValidationClass('servico_codigo')">
                      <label for="servico_codigo">Código do Serviço</label>
                      <md-input
                        v-model="form.servico_codigo"
                        name="servico_codigo"
                        id="servico_codigo"
                        :disabled="sending"
                        required
                      />
                      <span
                        class="md-error"
                        v-if="!$v.form.servico_codigo.required"
                        >O código do serviço é obrigatório</span
                      >
                    </md-field>
                  </div>
                </md-tab>

                <md-tab id="tab-pages" md-label="Composição">
                  <div class="materias-primas-container">
                    <md-button class="md-raised md-primary" @click="dialogoMateriaPrima = true">Adicionar materia prima</md-button>
                    <md-table v-model="materiasPrimas">
                      <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                        <md-table-cell md-label="Item" md-sort-by="estoqueItem_nome" md-numeric>{{ item.estoque_item.estoqueItem_nome }}</md-table-cell>
                        <md-table-cell md-label="Item - Unidade de Medida" md-sort-by="unidadeMedida_nome" md-numeric>{{ item.estoque_item.unidade_medida.unidadeMedida_nome }}</md-table-cell>
                        <md-table-cell md-label="Quantidade" md-sort-by="servicoMateriaPrima_quantidade" md-numeric>{{ item.servicoMateriaPrima_quantidade }}</md-table-cell>
                        <md-table-cell md-label="Fator" md-sort-by="fator" md-numeric>{{ item.fator }}</md-table-cell>
                        <md-table-cell md-label="Tamanho" md-sort-by="servicoMateriaPrima_fatorTamanho" md-numeric>{{ item.servicoMateriaPrima_fatorTamanho }}</md-table-cell>
                        <md-table-cell>
                          <md-button class="md-primary" @click="editarMateriaPrima(item.servicoMateriaPrima_id)"><md-icon>edit</md-icon></md-button>
                          <md-button class="md-accent" @click="removerMateriaPrima(item.servicoMateriaPrima_id)"><md-icon>clear</md-icon></md-button>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </md-tab>

                <md-tab id="tab-favorites" md-label="Custo">
                  <div>
                    <md-field>
                      <label for="servico_icms">ICMS (%)</label>
                      <md-input
                        v-model="form.servico_icms"
                        name="servico_icms"
                        id="servico_icms"
                        :disabled="sending"
                      />
                    </md-field>

                    <md-field>
                      <label for="servico_iss">ISS (%)</label>
                      <md-input
                        v-model="form.servico_iss"
                        name="servico_iss"
                        id="servico_iss"
                        :disabled="sending"
                      />
                    </md-field>

                    <md-field>
                      <label for="servico_custosFixos">Custos Fixos (%)</label>
                      <md-input
                        v-model="form.servico_custosFixos"
                        name="servico_custosFixos"
                        id="servico_custosFixos"
                        :disabled="sending"
                      />
                    </md-field>

                    <md-field>
                      <label for="servico_outrosCustos">Outros Custos (%)</label>
                      <md-input
                        v-model="form.servico_outrosCustos"
                        name="servico_outrosCustos"
                        id="servico_outrosCustos"
                        :disabled="sending"
                      />
                    </md-field>

                    <md-field :class="getValidationClass('servico_lucratividade')">
                      <label for="servico_lucratividade">Lucratividade (%)</label>
                      <md-input
                        v-model="form.servico_lucratividade"
                        name="servico_lucratividade"
                        id="servico_lucratividade"
                        :disabled="sending"
                        required
                      />
                      <span
                        class="md-error"
                        v-if="!$v.form.servico_lucratividade.required"
                        >Você deve inserir o percentual de lucratividade</span
                      >
                    </md-field>
                  </div>
                </md-tab>

                <md-tab md-alignment="left" id="tab-simulacao" md-label="Simulação">
                  <div>
                    <div class="md-layout md-gutter">
                      <div class="md-layout-item md-small-size-10">
                        <md-field>
                          <label for="simulacao_largura">Largura</label>
                          <md-input 
                          type="number"
                          v-model="simulacaoForm.simulacao_largura"
                          name="simulacao_largura" 
                          id="simulacao_largura"
                          required/>
                        </md-field>
                      </div>

                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="simulacao_comprimento">Comprimento</label>
                          <md-input 
                          v-model="simulacaoForm.simulacao_comprimento"
                          type="number"
                          name="simulacao_comprimento" 
                          id="simulacao_comprimento"
                          required/>
                        </md-field>
                      </div>

                      <div class="md-layout-item md-small-size-100">
                        <md-field>
                          <label for="simulacao_area">Área total (m²)</label>
                          <md-input 
                          v-model="simulacaoForm.simulacao_area"
                          disabled
                          type="number"
                          name="simulacao_area"
                          id="simulacao_comprimento"
                          required/>
                        </md-field>
                      </div>
                    </div>
                  </div>

                  <div>
                    <md-table v-model="simulacaoData.composicao">
                      <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
                        <md-table-cell md-label="Materia Prima">{{ item.materia_prima }}</md-table-cell>
                        <md-table-cell md-label="Quantidade">{{ item.quantidade }} {{item.unidadeMedida_codigo}}</md-table-cell>
                        <md-table-cell md-label="Valor">R$ {{ item.valor}}</md-table-cell>
                      </md-table-row>
                    </md-table>

                    <div style="text-align:left; margin-top: 25px">
                      <div v-if="simulacaoData.valor_total_composicao !== null">
                        <b>Custo total com matéria-prima:</b> R$ {{simulacaoData.valor_total_composicao}}
                      </div>
                      <div v-if="simulacaoData.valor_total !== null">
                        <b>Total:</b> R$ {{simulacaoData.valor_total}}
                      </div>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </form>
          </md-card-content>

          <md-card-actions md-alignment="left">
            <md-button
              class="md-primary"
              @click="saveAndToList"
              :disabled="sending"
              >Salvar</md-button
            >
            <md-button
              class="md-primary"
              :disabled="sending"
              @click="saveAndCreateNew"
              >Salvar e criar novo</md-button
            >
            <md-button class="md-accent" :disabled="sending" @click="cancel"
              >Cancelar</md-button
            >
          </md-card-actions>
        </md-card>
      </div>

      <md-snackbar :md-active.sync="showSnackMessage">{{
        snackMessage
      }}</md-snackbar>
    </div>

    <md-dialog  :md-active.sync="dialogoMateriaPrima">
      <md-dialog-title>Adicionar materia prima</md-dialog-title>

      <div class="form-materia-prima">
        <form>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getMateriaPrimaValidationClass('estoqueItem_id')">
                <label for="estoqueItem_id">Item</label>
                <md-select v-model="materiaPrimaForm.estoqueItem_id" name="estoqueItem_id" id="estoqueItem_id" required>
                  <md-option v-for="item in estoqueItens" :key="item.estoqueItem_id" :value="item.estoqueItem_id">
                    {{item.estoqueItem_nome}} - {{item.unidade_medida.unidadeMedida_nome}}
                  </md-option>
                </md-select>

                <span
                class="md-error"
                v-if="!$v.materiaPrimaForm.estoqueItem_id.required"
                >Você deve selecionar o material</span
                >
              </md-field>
            </div>

            <div class="md-layout-item md-small-size-100">
              <md-field :class="getMateriaPrimaValidationClass('servicoMateriaPrima_fator')">
                <label for="servicoMateriaPrima_fator">Fator</label>
                <md-select v-model="materiaPrimaForm.servicoMateriaPrima_fator" name="servicoMateriaPrima_fator" id="servicoMateriaPrima_fator" required>
                  <md-option value="area">Área</md-option>
                  <md-option value="largura">Largura</md-option>
                  <md-option value="comprimento">Comprimento</md-option>
                  <md-option value="personalizado">Personalizado</md-option>
                </md-select>

                <span class="md-helper-text">Fator de calculo da quantidade do item</span>

                <span
                class="md-error"
                v-if="!$v.materiaPrimaForm.servicoMateriaPrima_fator.required"
                >Você deve selecionar o fator</span
                >
              </md-field>
            </div>
          </div>

          <div v-if="fatorPersonalizado">
           <md-field :class="getMateriaPrimaValidationClass('servicoMateriaPrima_fatorFormula')">
                <label for="servicoMateriaPrima_fatorFormula">Formula</label>
                <md-input 
                type="text" 
                v-model="materiaPrimaForm.servicoMateriaPrima_fatorFormula" 
                name="servicoMateriaPrima_fatorFormula" 
                id="servicoMateriaPrima_fatorFormula"
                required/>

                <span class="md-helper-text">Insira a formula personalizada</span>

                <span
                class="md-error"
                v-if="!$v.materiaPrimaForm.servicoMateriaPrima_fatorFormula.required"
                >Você deve inserir a formula!</span
                >
            </md-field>
          </div>

          <div v-if="!fatorPersonalizado" class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getMateriaPrimaValidationClass('servicoMateriaPrima_fatorTamanho')">
                <label for="servicoMateriaPrima_fatorTamanho">Tamanho (metros)</label>
                <md-input 
                type="number" 
                v-model="materiaPrimaForm.servicoMateriaPrima_fatorTamanho" 
                name="servicoMateriaPrima_fatorTamanho" 
                id="servicoMateriaPrima_fatorTamanho"
                required/>

                <span class="md-helper-text">Tamanho em metros do fator escolhido.</span>

                <span
                class="md-error"
                v-if="!$v.materiaPrimaForm.servicoMateriaPrima_fatorTamanho.required"
                >Você deve inserir o tamanho</span
                >
              </md-field>
            </div>

            <div class="md-layout-item md-small-size-100">
              <md-field :class="getMateriaPrimaValidationClass('servicoMateriaPrima_quantidade')">
                <label for="servicoMateriaPrima_quantidade">Quantidade</label>
                <md-input 
                type="number" 
                v-model="materiaPrimaForm.servicoMateriaPrima_quantidade" 
                name="servicoMateriaPrima_quantidade" 
                id="servicoMateriaPrima_quantidade"
                required/>

                <span class="md-helper-text">Quantidade do item escolhido.</span>

                <span
                class="md-error"
                v-if="!$v.materiaPrimaForm.servicoMateriaPrima_quantidade.required"
                >Você deve inserir a quantidade de material</span
                >
              </md-field>
            </div>
          </div>
        </form>
      </div>

      <md-dialog-actions>
        <md-button class="md-primary md-accent" @click="dialogoMateriaPrima = false">Cancelar</md-button>
        <md-button class="md-raised md-primary" @click="salvarMateriaPrima()">Salvar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </mainTemplateVue>
</template>

<script>
import mainTemplateVue from "../../components/main-template.vue";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { api } from "../../services/api";

export default {
  name: "servico-form",
  components: {
    mainTemplateVue,
  },
  mixins: [validationMixin],
  data: () => ({
    id: null,
    materiasPrimas: [],
    simulacaoData: {
      valor_total: null,
      valor_total_composicao: null,
      composicao: []
    },
    estoqueItens: [],
    dialogoMateriaPrima: false,
    servicoMateriaPrimaId: null,
    valorTotalSimulado: "",
    seekingError: false,
    showSnackMessage: false,
    snackMessage: false,
    sending: false,
    saved: false,
    error: false,
    materiaPrimaForm: {
      estoqueItem_id: null,
      servicoMateriaPrima_fator: '',
      servicoMateriaPrima_fatorTamanho: null,
      servicoMateriaPrima_quantidade: null,
      servicoMateriaPrima_fatorFormula: null
    },
    simulacaoForm: {
      simulacao_largura: null,
      simulacao_comprimento: null,
      simulacao_area: null
    },
    form: {
      servico_nome: "",
      servico_codigo: "",
      servico_icms: null,
      servico_iss: null,
      servico_custosFixos: null,
      servico_outrosCustos: null,
      servico_lucratividade: null
    }
  }),
  computed: {
    simulacaoAreaComputada() {
      return this.simulacaoForm.simulacao_area;
    },
    fatorPersonalizado(){
      return this.materiaPrimaForm.servicoMateriaPrima_fator == "personalizado"
    }
  },
  validations: {
    form: {
      servico_nome: {
        required,
        minLength: minLength(3),
      },
      servico_codigo: {
        required,
      },
      servico_lucratividade: {
        required
      }
    },
    materiaPrimaForm: {
      estoqueItem_id: {
        required
      },
      servicoMateriaPrima_fator: {
        required
      },
      servicoMateriaPrima_fatorTamanho: {
      },
      servicoMateriaPrima_quantidade: {
      },
      servicoMateriaPrima_fatorFormula: {
      }
    }
  },
  watch: {
    dialogoMateriaPrima: {
      handler(to) {
        if(!to) {
          this.servicoMateriaPrimaId = null
          this.materiaPrimaForm.estoqueItem_id = null
          this.materiaPrimaForm.servicoMateriaPrima_fator = ''
          this.materiaPrimaForm.servicoMateriaPrima_fatorTamanho = null
          this.materiaPrimaForm.servicoMateriaPrima_quantidade = null
        }
      }, deep: true
    },
    simulacaoForm: {
      handler() {
        this.simulacaoForm.simulacao_area = this.simulacaoForm.simulacao_comprimento * this.simulacaoForm.simulacao_largura

        
        
      }, deep: true
    },
    simulacaoAreaComputada(to, old) {
      if(to !== old) {
        this.getSimulacaoData();
      }
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    getMateriaPrimaValidationClass(fieldName) {
      const field = this.$v.materiaPrimaForm[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    getSimulacaoData(){
      api().get(`servico/${this.id}/custo`, {
        params: {
          largura: this.simulacaoForm.simulacao_largura,
          comprimento: this.simulacaoForm.simulacao_comprimento,
          area: this.simulacaoForm.simulacao_area
        }
      }).then(r => {
        this.simulacaoData = r.data.data
      })
    },
    salvarMateriaPrima(){
      this.$v.materiaPrimaForm.$touch();

      if (!this.$v.materiaPrimaForm.$invalid) {
        if(!this.servicoMateriaPrimaId){
          api().post(`servico/${this.id}/materiaPrima`, this.materiaPrimaForm).then(() => {
            this.dialogoMateriaPrima = false
            this.showSnackMessage = true
            this.snackMessage = "Materia prima adicionada com sucesso"
            this.getMateriasPrimas()
          })
        } else {
          api().put(`servico/materiaPrima/${this.servicoMateriaPrimaId}`, this.materiaPrimaForm).then(() => {
            this.dialogoMateriaPrima = false
            this.showSnackMessage = true
            this.snackMessage = "Materia prima atualizada com sucesso"
            this.getMateriasPrimas()
          })
        }
      }
    },
    removerMateriaPrima(id){
      api().delete(`servico/materiaPrima/${id}`).then(() => {
        this.showSnackMessage = true
        this.snackMessage = "Materia prima removida com sucesso"

        this.getMateriasPrimas()
      })
    },
    editarMateriaPrima(id){
      this.servicoMateriaPrimaId = id
      api().get(`servico/materiaPrima/${id}`).then((r) => {
        this.dialogoMateriaPrima = true
        this.materiaPrimaForm = r.data.data
      })
    },
    async saveAndCreateNew() {
      this.$v.form.$touch();


      if (!this.$v.form.$invalid) {
        this.save()
          .then(() => {
            this.$router.push({ path: "/servico/novo" });
            this.form.servico_nome = ""
            this.form.servico_codigo = ""
            this.form.servico_icms = null
            this.form.servico_iss = null
            this.form.servico_custosFixos = null
            this.form.servico_outrosCustos = null
            this.form.servico_lucratividade = null
          })
          .catch(() => {
            this.error = true;
          });
      }
    },

    async saveAndToList() {
      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.save()
          .then(() =>
            setTimeout(() => {
              this.$router.push({ path: "/servico" });
            }, 1000)
          )
          .catch(() => (this.error = true));
      }
    },

    async save() {
      this.sending = true;

      let res;

      if (this.id !== null) {
        res = await api().put(`/servico/${this.id}`, this.form);
      } else {
        res = await api().post("/servico", this.form);
      }

      this.sending = false;
      this.showSnackMessage = true;
      this.snackMessage = true;

      if (!res) {
        this.snackMessage = "Ocorreu um erro ao salvar o registro";
        return false;
      }

      this.snackMessage = "Registro salvo com sucesso";

      return true;
    },

    async getItem() {
      this.sending = true;

      let res = await api().get(`/servico/${this.id}`);

      if (!res) {
        this.seekingError = true;
        return false;
      }

      this.sending = false;
      this.form = { ...res.data.data };
      this.form.es;
    },

    cancel() {
      this.$router.push({ path: "/servico" });
    },

    async getUnidadesMedida() {
      let req = await api().get("estoque/medida");
      this.unidadesMedida = req.data.data;
    },

    async getEstoqueItens() {
      let req = await api().get("estoque/item");
      this.estoqueItens = req.data.data;
    },

    async getMateriasPrimas(){
      let res = await api().get(`/servico/${this.id}/materiaPrima`);
      this.materiasPrimas = res.data.data;
    }
  },

  created() {
    this.getUnidadesMedida();
    this.getEstoqueItens();
    

    if (this.$route.params.id && !isNaN(this.$route.params.id)) {
      this.id = this.$route.params.id;
      this.getMateriasPrimas();
      this.getItem();
    }
  },

  mounted() {},
};
</script>
<style>
.md-table-head, .md-table-head.md-numeric {
    text-align: left !important;
}

.md-table-cell {
    text-align: left !important;
}
.materias-primas-container {
    text-align: left;
}
.md-dialog-container {
    width: 650px !important;
}
.form-materia-prima {
    padding: 25px;
}
</style>